import React, { useEffect, useState } from 'react'
import { Grid, Typography, Box, Button, TextField } from '@material-ui/core'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { format, isValid } from 'date-fns'

const Header = ({ lead, filterStyles, classes, handleOpenTransferOs }) => {
  const [schedulingDate, setSchedulingDate] = useState(null)

  const handleChangeSchedulingDate = date => {
    if (!isValid(date)) return setSchedulingDate(date)
    setSchedulingDate(format(date, 'yyyy-MM-dd'))
  }

  useEffect(() => {
    const handleInitSchedulingDate = () => {
      if (!lead?.scheduling_date) return
      setSchedulingDate(lead?.scheduling_date)
    }
    handleInitSchedulingDate()
  }, [lead?.scheduling_date])

  return (
    <Box className={classes.box}>
      <Grid container alignItems="center">
        <Grid item xs={3}>
          <Grid container spacing={1}>
            <Grid item>
              <Typography style={{ fontWeight: 'bold' }}>
                Capturado por:
              </Typography>
            </Grid>
            <Grid item>
              <Typography>{lead?.user_capture}</Typography>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={3}>
          <Grid container spacing={1}>
            <Grid item>
              <Typography style={{ fontWeight: 'bold' }}>
                Estado Atual:
              </Typography>
            </Grid>
            <Grid item>
              <Typography>{lead?.state}</Typography>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={4}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item>
              <Typography style={{ fontWeight: 'bold' }}>
                Data de agendamento:
              </Typography>
            </Grid>
            <Grid item>
              <TextField
                style={{ display: 'none' }}
                id="input-date-control"
                value={schedulingDate}
                name="scheduling_date_crm"
              />

              <KeyboardDatePicker
                clearable
                style={{ maxWidth: '130px' }}
                value={`${schedulingDate} 00:00:00`}
                onChange={handleChangeSchedulingDate}
                clearLabel="Limpar"
                invalidDateMessage="Data inválida"
                autoOk
                inputVariant="standard"
                format="dd/MM/yyyy"
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={2}>
          <Grid container spacing={1} justifyContent="flex-end">
            <Grid item>
              <Button
                className={filterStyles.btnAdd}
                style={{ textTransform: 'none' }}
                onClick={handleOpenTransferOs}
              >
                Transferir OS
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  )
}

export default Header
